/*jslint nomen: true */
'use strict';

var $ = require('jquery');
var isClickOrSpaceOrEnter = require('./util').isClickOrSpaceOrEnter;

function showPassword() {
    $('.password-show-btn').on('click keypress', function (event) {
        // Getting ID and creating variables
        if (isClickOrSpaceOrEnter(event)) {
            var $this = $(this);
            var showPasswordTxt = $this.find('.password-show-text-show').text();
            var hidePasswordTxt = $this.find('.password-show-text-hide').text();

            var scope = $this.parents('form');
            var passwordInputName = $this.attr('atttest');
            var passwordInputName_selector = '[name="' + passwordInputName + '"]';
            var passwordInputName_icon = '.icon_' + passwordInputName;
            var passwordInputName_iconClasses = '.icon.icon-password-hide.icon_' + passwordInputName;

            // Toggle Visible / Hide icons
            $(passwordInputName_icon).toggleClass('password-off');
            $this.toggleClass('password-off');

            // Changing the input type (password / type)
            if ($(passwordInputName_iconClasses).hasClass('password-off')) {
                $(passwordInputName_selector, scope).prop('type', 'text');
                $this.attr('aria-label', hidePasswordTxt);
            } else {
                $(passwordInputName_selector, scope).prop('type', 'password');
                $this.attr('aria-label', showPasswordTxt);
            }
        }
    });
}

module.exports = {
    init: function () {
        showPassword();
    }
};
